import type { IVehicle } from "@domain/Vehicle";
import { useViewModelInstance } from "../Types/MyGarageViewModelStore";

class VehicleService
{

    /**
     * Gets the active vehicle from the MyGarage view model instance
     * @returns 
     */
    async getActiveVehicle(): Promise<IVehicle|null>
    {
        const myGarageViewModel = await useViewModelInstance();
        return  myGarageViewModel.vehicle;
    }

}

export function useVehicleService()
{
    return new VehicleService();
}